import { Pageable } from "./pageable";
import { Page } from "../models/page";

export interface NotifyManagementSendItem {
  id: string;
  notifyFeatureId?: string;
  title?: string;
  order?: number;
  creationDate?: string;
  createdById?: string;
}

export interface NotifyManagementSendPage extends Pageable {
  content: NotifyManagementSendItem[];
}

export type NotifyTimelineStatus = 'FUTURE' | 'TODAY' | 'PAST' | 'UNSCHEDULED';

export interface NotifyManagementHistoryFilter {
  title?: string;
  creationDateStart?: string;
  creationDateEnd?: string;
  publishingDateStart?: string;
  publishingDateEnd?: string;
  publishingHourStart?: string;
  publishingHourEnd?: string;
  createdById?: string;
  lastModifiedById?: string;
  schedule?: boolean;
  timelineStatus?: NotifyTimelineStatus | '';
  sort?: string[];
}

export interface NotifyManagementHistoryItem {
  id: string;
  title?: string;
  name?: string;
  creationDate?: string;
  lastModifiedDate?: string;
  publishingDate?: string;
  publishingHour?: string;
  schedule?: boolean;
  createdById?: string;
  lastModifiedById?: string;
  timelineStatus?: NotifyTimelineStatus | string;
}

export interface NotifyManagementHistoryPage extends Pageable {
  content: NotifyManagementHistoryItem[];
}

export interface Notify {
  id: string
  name: string;
  title: string;
  message: string;
  ico: string;
  icoUrl?: string;
  content: string;
  schedule: boolean;
  notifyInteraction: NotifyInteraction;
  publishingDate: string;
  publishingHour?: string;
  creationDate?: string;
  viewed?: boolean;
  viewDate?: string;
  lastModifiedDate?: string;
  receiver?: string;
  createdById?: string;
  createdByIp?: string;
  groups?: any[];
  groupsInfo?: any[];
  users?: any[];
  usersInfo?: any[]
  activity?: boolean;
  sendDate?: any;
  publisherService?: any;
  homePage?: HomePage[];
  htmlPlus?: any[];

}

export interface PageableNotify extends Pageable {
  content: Notify[]
}

export interface NotifyInteraction {
  type: NotifyLinkType;
  requiredInteractionChk: boolean;
  requiredInteractionChkTxt: string;
  requiredInteractionBtnChkTxt: string;
  pageId: string;
  menuId?: string,
  requiredInteractionPageBtnTxt: string;
  urlTitle: string;
  url: string;
  page?: Page;
  domain?: string;
}

export enum NotifyLinkType {
  none = 'NONE',
  page = 'PAGE',
  link = 'LINK',
  url = 'URL'
}

export enum NotifyRecipientsType {
  all = 'ALL',
  recipients = 'SELECTED'
}

export interface NotifyStats {
  notViewsPercentage: number;
  notifyConfigId: string;
  creationDate: string;
  notViews: number;
  interactions: number;
  total: number;
  viewsPercentage: number;
  createdBy: CreatedBy;
  interactionsPercentage: number;
  notifyConfigName: string;
  notInteractionsPercentage: number;
  notificationHasInteraction: boolean;
  createdById: string;
  views: number;
  order: number;
  notInteractions: number;
}
export interface CreatedBy {
  birthday: boolean;
  notViewUser: boolean;
  clientId: string;
  coverImage: CoverImage;
  fullName: string;
  photo: Photo;
  id: string;
  login: string;
  status: string;
}

export interface HomePage {
  id: string;
  homePageId: string;
  clientId: string;
}

export interface CoverImage {
  mediaId: string;
}

export interface Photo {
  mediaUrl: string;
  mediaId: string;
}

